import { createRoot } from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";
import App from "./App.tsx";
import "./index.css";
import heroImg from "@/assets/bestseller-zorro-hero.jpeg";

// Preload LCP hero image as early as possible to reduce Resource Load Delay.
// The URL matches the hashed asset emitted by Vite.
if (typeof document !== "undefined") {
  const link = document.createElement("link");
  link.rel = "preload";
  link.as = "image";
  link.href = heroImg;
  link.fetchPriority = "high";
  document.head.appendChild(link);
}

createRoot(document.getElementById("root")!).render(
  <HelmetProvider>
    <App />
  </HelmetProvider>
);
